import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Output,
	ViewEncapsulation,
} from "@angular/core";

import { CompleteAccountLoginDialogService } from "../complete-account-login/complete-account-login.dialog";

@Component({
	selector: "obg-m-migrated-user-welcome-container",
	styleUrls: ["./migrated-user-welcome-container.scss"],
	templateUrl: "./migrated-user-welcome-container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MigratedUserWelcomeContainer {
	@HostBinding("class.obg-m-migrated-user-welcome-container") hostClass = true;

	@Output() close = new EventEmitter<void>();
	@Output() busy = new EventEmitter<boolean>();

	constructor(private completeAccountLoginDialog: CompleteAccountLoginDialogService) {}

	navigateToCompleteAccountLogin() {
		this.busy.emit(true);
		this.close.emit();
		this.completeAccountLoginDialog.open();
	}
}
